<script lang="ts">
  import type { Conversation } from '../../shared/types';
  import { post } from '../api';
  import { rememberRoomOwner } from '../roomOwners';
  import { chat } from '../store';

  interface Props {
    mode: 'room' | 'join';
    onClose: () => void;
  }

  let { mode, onClose }: Props = $props();
  let value = $state('');
  let error = $state<string | null>(null);
  let busy = $state(false);

  async function submit() {
    if (!value.trim() || busy) return;
    busy = true;
    error = null;
    try {
      const path = mode === 'room' ? '/api/mesh/rooms' : '/api/mesh/join';
      const body = mode === 'room' ? { name: value.trim(), authorId: chat.getState().me.id } : { invite: value.trim() };
      const result = await post<{ conversation: Conversation; ownerKey?: string }>(path, body);
      if (result.ownerKey) rememberRoomOwner(result.conversation.id, result.ownerKey);
      chat.upsertConversation(result.conversation);
      chat.setActive(result.conversation.id);
      onClose();
    } catch (cause) {
      error = (cause as Error).message;
    } finally {
      busy = false;
    }
  }
</script>

<div class="modal-backdrop" role="presentation" onclick={onClose}>
  <div class="modal small" role="dialog" aria-modal="true" onclick={(event) => event.stopPropagation()}>
    <header class="modal-head">
      <strong>{mode === 'room' ? 'New mesh room' : 'Join mesh room'}</strong>
    </header>
    <div class="modal-body">
      <input
        autofocus
        bind:value
        onkeydown={(event) => {
          if (event.key === 'Enter') void submit();
        }}
        placeholder={mode === 'room' ? 'Room name' : 'Invite code'}
      />
      <p class="hint">
        {mode === 'room'
          ? 'Messages replicate directly between peers over Hyperswarm.'
          : 'Ask the room owner for the invite code shown in its chat header.'}
      </p>
      {#if error}<p class="status error">{error}</p>{/if}
    </div>
    <footer class="modal-foot">
      <button class="btn" onclick={() => void submit()} disabled={busy || !value.trim()}>
        {mode === 'room' ? 'Create room' : 'Join'}
      </button>
      <button class="btn ghost" onclick={onClose}>Cancel</button>
    </footer>
  </div>
</div>
